// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__28N4E","title":"AfterFrontImage_title__36uhu"};